import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

/**
 * A small portaled tooltip for the roster — a dark, high-contrast chip with a
 * caret, fading and rising in, used for two different hints that both used
 * to be bare-bones: a roster name's sub-workspace (Sales → Field Sales,
 * In-House Sales…), which used to sit inline as a pill until a long name and
 * a long sub-workspace together had nowhere to go in the roster's own
 * fixed-width column and the pill got clipped mid-word; and the Pay/hour
 * button's own hint, which used to be a native `title` — serviceable, but it
 * reads as an afterthought next to every other hover surface this card
 * already has (PerfPopover, PayPopover). This borrows their look instead.
 *
 * Portaled to <body> for the same reason those two are: the roster's own
 * scroll/clip ancestors (.lbr-emp-animate-in, .lbr-scroll) would otherwise
 * cut it off the moment it drifts past their edge.
 */
const InlineTip = ({ anchor, text }) => {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setShown(true));
    return () => cancelAnimationFrame(raf);
  }, [anchor]);

  if (!anchor) return null;

  return createPortal(
    <span
      className={`lbr-subtip${shown ? " in" : ""}`}
      style={{ top: anchor.top, left: anchor.left }}
    >
      {text}
    </span>,
    document.body,
  );
};

InlineTip.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  anchor: PropTypes.object,
  text: PropTypes.string,
};
InlineTip.defaultProps = { anchor: null, text: "" };

export default InlineTip;
